import styled from '@emotion/styled';
import * as s from '@identity/spacing';
import * as c from '@identity/constants';

export const Wrapper = styled.div`
  ${({ space }) => space && s.spacing(space)};

  display: flex;
  max-width: 85ch;
  margin: 0 auto;

  p {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  small {
    font-weight: 600;
    display: block;
    margin: 10px 0;
  }

  h3 {
    transition: all 250ms ease-in-out;
  }

  :hover h3 {
    color: ${props => !props.noLink && c.colors.PRIMARY_004};
  }
`;

export const ImageWrapper = styled.figure`
  padding-right: 15px;

  img {
    border-radius: 50%;
    width: 40px;
  }
`;
